
import * as angular from "angular";
import { headerComponent } from "./header.component";
import { InstanceSettingsService, INSTANCE_SETTINGS_SERVICE } from "../../instance-settings/instance-settings.service";

import instanceSettingsModule from "../../instance-settings/instance-settings.module";

export default angular
        .module("board.web.admin.header", [instanceSettingsModule])
        .component("brdHeader", headerComponent)
        .name;


// WEBPACK FOOTER //
// ./app/layout/header/header.module.ts